import React from "react";
import { CheckCircle2, AlertTriangle } from "lucide-react";

/**
 * SubmitDialog
 * Confirms submission. If there are unanswered questions, warns the person
 * and lists them so they can jump straight back rather than hunting.
 */
const SubmitDialog = ({
  open,
  onClose,
  onConfirm,
  unanswered,
  onJumpTo,
  submitting,
}) => {
  if (!open) return null;

  const hasUnanswered = unanswered.length > 0;

  return (
    <div className="submit-dialog-overlay" role="dialog" aria-modal="true">
      <div className="submit-dialog">
        <div className={`dialog-icon ${hasUnanswered ? "warning" : ""}`}>
          {hasUnanswered ? <AlertTriangle /> : <CheckCircle2 />}
        </div>

        <h3>
          {hasUnanswered
            ? "A few questions are still open"
            : "Ready to submit?"}
        </h3>
        <p>
          {hasUnanswered
            ? `You have ${unanswered.length} unanswered question${unanswered.length === 1 ? "" : "s"}. You can go back and finish them, or submit anyway.`
            : "Every question has an answer. Once submitted, you won't be able to change your responses."}
        </p>

        {hasUnanswered && (
          <div className="dialog-unanswered-list">
            {unanswered.map((u) => (
              <button
                key={u.flatIndex}
                type="button"
                onClick={() => onJumpTo(u.flatIndex)}
              >
                Question {u.flatIndex + 1} — {u.sectionTitle}
              </button>
            ))}
          </div>
        )}

        <div className="dialog-actions">
          <button type="button" onClick={onClose}>
            Keep editing
          </button>
          <button
            type="button"
            className="confirm"
            onClick={onConfirm}
            disabled={submitting}
          >
            {submitting
              ? "Submitting…"
              : hasUnanswered
                ? "Submit anyway"
                : "Submit assessment"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SubmitDialog;
